import logo from './logo.svg';
import './App.css';
import React, { useEffect, useState } from 'react';
import { getHello } from './api';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import NotFound from './NotFound';

function Home() {
  const [message, setMessage] = useState('');
  useEffect(() => {
    getHello().then(data => setMessage(data.message)).catch(() => setMessage('API call failed'));
  }, []);
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>{message}</p>
      </header>
    </div>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default App;
